import { useState, useEffect, useRef } from "react";
import { useAppContext } from "@/context/Context";
import { useUser } from "@/context/UserContext";
import StudentNotifications from "../StudentNotifications";
import HRWishlist from "../HRWishlist";
import HRNotifications from "../HRNotifications";
import InstructorNotifications from "../InstructorNotifications";
import AdminNotifications from "../AdminNotifications";
import InstructorTools from "../InstructorTools";
import LoginDropdown from "../LoginDropdown";
import UserMenu from "../UserMenu";
import ReferralButton from "../ReferralButton";
import Link from "next/link";
import Wallet from "./Wallet";

const HeaderRightTwo = ({ userType }) => {
  const { mobile, setMobile } = useAppContext();
  const { user } = useUser();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showContactMenu, setShowContactMenu] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const contactMenuRef = useRef(null);
  const hoverTimeoutRef = useRef(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedUser = localStorage.getItem("user");
      setIsLoggedIn(!!storedUser);
    }
  }, [user]);

  useEffect(() => {
    const checkMobileView = () => {
      setIsMobileView(window.innerWidth <= 1199);
    };

    checkMobileView();
    window.addEventListener("resize", checkMobileView);

    return () => window.removeEventListener("resize", checkMobileView);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutsideContact =
        contactMenuRef.current &&
        !contactMenuRef.current.contains(event.target);

      if (isOutsideContact) {
        setShowContactMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, []);

  const handleContactMouseEnter = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    setShowContactMenu(true);
  };

  const handleContactMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setShowContactMenu(false);
    }, 200);
  };

  const handleOverlayMouseEnter = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
  };

  const handleOverlayMouseLeave = () => {
    setShowContactMenu(false);
  };

  return (
    <div className="header-right">
      <ul className="quick-access">
        {isLoggedIn && user?.role === "student" && <ReferralButton user={user} />}

        {isLoggedIn && user?.role === "student" && <Wallet user={user} />}

        {isLoggedIn && user?.role === "student" && user?._id && (
          <StudentNotifications userId={user._id} />
        )}

        {isLoggedIn && user?.role === "hr" && user?._id && (
          <HRNotifications userId={user._id} />
        )}

        {isLoggedIn && user?.role === "instructor" && user?._id && (
          <>
            <InstructorNotifications userId={user._id} />
            <InstructorTools userId={user._id} />
          </>
        )}

        {isLoggedIn && user?.role === "admin" && (
          <AdminNotifications />
        )}

        {!isMobileView && (
          <li
            ref={contactMenuRef}
            className="access-icon rbt-notification-wrapper rbt-notification-position"
          >
            <Link
              href="/contact"
              className="rbt-round-btn"
              onMouseEnter={handleContactMouseEnter}
              onMouseLeave={handleContactMouseLeave}
              aria-label="Contact us"
              title="Contact us"
            >
              <i className="feather-phone"></i>
            </Link>

            {showContactMenu && (
              <div
                className="rbt-job-notification-overlay"
                onMouseEnter={handleOverlayMouseEnter}
                onMouseLeave={handleOverlayMouseLeave}
                style={{ minWidth: "200px" }}
              >
                <div className="rbt-job-overlay-header">
                  <h6 className="rbt-job-overlay-title">Contact Us</h6>
                </div>

                <ul className="rbt-job-overlay-list">
                  <li className="rbt-job-overlay-item">
                    <a
                      href="tel:+919562461503"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      <i
                        className="feather-phone"
                        style={{ marginRight: "8px", fontSize: "14px" }}
                      ></i>
                      <div className="rbt-job-overlay-title-text">
                        +91 9562461503
                      </div>
                    </a>
                  </li>

                  <li className="rbt-job-overlay-item">
                    <a
                      href="mailto:info@emdeondigital.com"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      <i
                        className="feather-mail"
                        style={{ marginRight: "8px", fontSize: "14px" }}
                      ></i>
                      <div className="rbt-job-overlay-title-text">
                        info@emdeondigital.com
                      </div>
                    </a>
                  </li>

                  <li className="rbt-job-overlay-item">
                    <Link
                      href="/contact"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      <i
                        className="feather-message-circle"
                        style={{ marginRight: "8px", fontSize: "14px" }}
                      ></i>
                      <div className="rbt-job-overlay-title-text">
                        Contact Page
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            )}
          </li>
        )}

        {!isLoggedIn ? <LoginDropdown /> : <UserMenu userType={userType} />}
      </ul>

      <div className="mobile-menu-bar d-block d-xl-none">
        <div className="hamberger">
          <button
            className="hamberger-button rbt-round-btn"
            onClick={() => setMobile(!mobile)}
            aria-label="Open menu"
            title="Open menu"
          >
            <i className="feather-menu"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeaderRightTwo;
